import { api } from './api';
import { getMe } from '../actions/auth';
import { unauthorizedError } from './state';

export const listInAppNotifications = () => (dispatch) => {
  return api
    .get('/admin/in-app-notifications')
    .then((response) => {
      dispatch({ type: 'LIST_IN_APP_NOTIFICATIONS', data: response.data });
    })
    .catch(function (error) {
      console.log('ERROR', error);
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const create = (item) => (dispatch) => {
  return api
    .post(`/admin/in-app-notifications/${item._id}`, item)
    .then((response) => {
      alert('Created');
      dispatch(getMe());
    })
    .catch(function (error) {
      alert('Create ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const update = (item) => (dispatch) => {
  return api
    .put(`/admin/in-app-notifications/${item._id}`, item)
    .then((response) => {
      alert('Updated');
      dispatch(getMe());
    })
    .catch(function (error) {
      alert('Update ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const duplicate = (id, internalName, startDate, endDate) => (dispatch) => {
  return api
    .post(`/admin/in-app-notifications/${id}/duplicate`, {
      internalName,
      start_date: startDate,
      end_date: endDate,
    })
    .then((response) => {
      alert('Notification duplicated!');
      dispatch(listInAppNotifications());
    })
    .catch(function (error) {
      alert('Update ERROR');
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const remove = (id) => (dispatch) => {
  return api
    .delete(`/admin/in-app-notifications/${id}`)
    .then((response) => {
      alert('Deleted');
      dispatch(getMe());
    })
    .catch(function (error) {
      alert('Delete ERROR');
      console.log(error);
      console.log(error.response.data);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};
